import React from 'react';

import { Link } from 'react-router-dom';
import { Grid, Link as MuiLink, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { useFindPublicCategories } from '../../../categories/hooks/public/find-categories.hook';
import { PUBLIC_PRODUCTS_APP_PATHS } from '../../../products/constants/public-products-paths.constants';
import backgroundFooter from '../../../assets/img/backgrounds/background-footer.png';
import { usePanel } from '../hooks/use-panel.hook';
import { PUBLIC_PANELS } from '../constants/panel.constants';

const MAX_SHOP_LINKS = 5;

const useStyles = makeStyles((theme) => ({
  footer: {
    background: `#c29d6d url(${backgroundFooter}) repeat center center scroll`,
    padding: '32px 16px 16px',

    [theme.breakpoints.up('md')]: {
      padding: '48px 24px 24px',
    },
  },
  inner: {
    maxWidth: 1280,
    margin: '0 auto',
  },
  columnTitle: {
    fontFamily: 'Bitter, serif',
    fontWeight: 700,
    fontSize: '0.95rem',
    color: '#3F4A12 ',
    marginBottom: '0.4rem',
  },
  link: {
    display: 'block',
    color: '#4a3520',
    textDecoration: 'none',
    fontSize: '0.9rem',
    padding: '0.2rem 0',

    '&:hover': {
      color: theme.palette.client.primary.extraDark,
    },
  },
  certification: {
    marginTop: 24,
    paddingTop: 16,
    borderTop: '1px solid rgba(74, 53, 32, 0.25)',
    color: '#4a3520',
    fontSize: '0.8rem',
    textAlign: 'center',
  },
}));

const PublicFooter: React.FC = () => {
  const classes = useStyles();
  const { categories } = useFindPublicCategories();
  const { openPanel } = usePanel();
  const shopCategories = categories.slice(0, MAX_SHOP_LINKS);

  return (
    <footer className={classes.footer}>
      <div className={classes.inner}>
        <Grid container spacing={4}>
          <Grid item xs={6} sm={3}>
            <Typography className={classes.columnTitle}>Offre entreprise</Typography>
            <Link className={classes.link} to="/offre-entreprise">
              Une offre adaptée
            </Link>
            <Link className={classes.link} to="/corbeille-fruit">
              Corbeille de fruits
            </Link>
          </Grid>

          <Grid item xs={6} sm={3}>
            <Typography className={classes.columnTitle}>{`L'offre`}</Typography>
            {shopCategories.map((category) => (
              <Link
                key={category.id}
                className={classes.link}
                to={PUBLIC_PRODUCTS_APP_PATHS.CATALOG_FOR(category.slug)}
              >
                {category.name}
              </Link>
            ))}
          </Grid>

          <Grid item xs={6} sm={3}>
            <Typography className={classes.columnTitle}>Bio Culture</Typography>
            <Link className={classes.link} to="/nos-valeurs">
              Nos valeurs
            </Link>
            <Link className={classes.link} to="/nos-produits">
              Nos produits
            </Link>
            <Link className={classes.link} to="/nos-producteurs">
              Nos producteurs
            </Link>
            <Link className={classes.link} to="/zero-dechets">
              Zéro déchet
            </Link>
            <Link className={classes.link} to="/contact">
              Nous écrire
            </Link>
          </Grid>

          <Grid item xs={6} sm={3}>
            <Typography className={classes.columnTitle}>Mentions légales</Typography>
            <Link className={classes.link} to="/cgv">
              CGV
            </Link>
            <Link className={classes.link} to="/mentions-legales">
              Mentions légales
            </Link>
            <MuiLink
              component="button"
              type="button"
              className={classes.link}
              onClick={() => openPanel(PUBLIC_PANELS.SIGNUP)}
            >
              {`S'inscrire`}
            </MuiLink>
            <MuiLink
              component="button"
              type="button"
              className={classes.link}
              onClick={() => openPanel(PUBLIC_PANELS.LOGIN)}
            >
              Se connecter
            </MuiLink>
          </Grid>
        </Grid>

        <Typography className={classes.certification}>Certifié par Ecocert FR-BIO-01</Typography>
      </div>
    </footer>
  );
};

export default PublicFooter;
